import SimpleChart from './generic/SimpleChart.vue'

[...document.getElementsByClassName("vue-chart")].forEach(item => {

  const chartId = item.id.replace('chart-block-', '');
  const dataScript = document.getElementById(`chart-data-${chartId}`);

  if (!dataScript) {
    return;
  }
  const props = JSON.parse(dataScript.textContent);

  createApp(SimpleChart, props).mount(item);

});